module.exports = __webpack_public_path__ + "img/01-3.6ba9b839.png";